<template>
  <div>
    <div id="body">
      <!-- <div
        :class="showIsHover ? 'top-filter-tabs is-hover' : 'top-filter-tabs'"
      >
        <div class="wrapper">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="国内宏观数据" name="2"></el-tab-pane>
            <el-tab-pane label="国内产量数据" name="1"></el-tab-pane>
            <el-tab-pane label="进出口数据" name="3"></el-tab-pane>
          </el-tabs>
        </div>
      </div> -->
      <div class="banner">
        <div class="wrapper">
          <div class="title">
            <h1>进出口数据</h1>
          </div>
        </div>
      </div>
      <div class="top-show">
        <div class="wrapper">
          <div class="search-filter">
            <el-form label-width="5.0em" size="small">
              <el-form-item label="地区：">
                <el-select v-model="selectRegion" placeholder="">
                  <el-option
                    v-for="(item, index) in districtNames"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="类型：">
                <el-radio-group v-model="jckType">
                  <el-radio label="jinkou">进口</el-radio>
                  <el-radio label="chukou">出口</el-radio>
                  <el-radio label="jinchukou">进出口</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="币制：">
                <el-radio-group v-model="jckMoney">
                  <el-radio label="rmb">人民币</el-radio>
                  <el-radio label="usd">美元</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="商品名：">
                <el-select
                  v-model="cnames"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="jinchukouDataNameRemote"
                  :loading="cnameLoading"
                  :multiple-limit="5"
                  popper-class="cnames-width"
                >
                  <el-option
                    v-for="item in jinchukouDataNameOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="日期：">
                <el-date-picker
                  v-model="selectDate"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  style="width: 316.5px"
                  format="yyyy年MM月"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item class="submit" label="">
                <el-button type="primary" @click="handleSearch">
                  检索
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="map" v-loading="mpaLoading">
          <div id="container" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="wrapper">
        <div class="search-top" v-if="showTable">
          <div class="search-top-time">
            <!-- <el-form size="small" inline>
              <el-form-item>
                <div slot="label">日期</div>
                <el-select
                  v-model="searchSort"
                  size="small"
                  @change="handleSortChange"
                >
                  <el-option :value="0" label="时间"></el-option>
                  <el-option :value="1" label="相关度"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleInstitutionSearch"
                  >检索</el-button
                >
              </el-form-item>
            </el-form> -->
            <el-tabs
              v-model="activeCName"
              @tab-click="handleRegionDataTabClick"
            >
              <el-tab-pane
                v-for="cname in cnameTabs"
                :label="cname"
                :name="cname"
                :key="cname"
              >
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="search-display">
            <el-button
              size="mini"
              type=""
              @click="handleExport"
              v-if="showTable && tableData && tableData.length > 0"
            >
              <svg
                t="1655450861977"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6279"
                width="200"
                height="200"
              >
                <path
                  d="M409.12 877.74H239.83c-51.27 0-92.98-41.71-92.98-93V239.29c0-51.27 41.71-92.98 92.98-92.98h545.45c51.29 0 93 41.71 93 92.98v169.29c0 20.2-16.38 36.57-36.57 36.57-20.2 0-36.57-16.38-36.57-36.57V239.29c0-10.95-8.91-19.84-19.86-19.84H239.83c-10.95 0-19.84 8.89-19.84 19.84v545.45c0 10.95 8.89 19.86 19.84 19.86h169.29c20.2 0 36.57 16.38 36.57 36.57s-16.37 36.57-36.57 36.57z"
                  p-id="6280"
                ></path>
                <path
                  d="M821.37 718.72H527.19c-20.2 0-36.57-16.38-36.57-36.57 0-20.2 16.38-36.57 36.57-36.57h294.18c20.2 0 36.57 16.38 36.57 36.57 0 20.2-16.37 36.57-36.57 36.57z"
                  p-id="6281"
                ></path>
                <path
                  d="M718.58 841.83c-9.36 0-18.71-3.57-25.86-10.71-14.29-14.29-14.29-37.45 0-51.71l97.25-97.25-97.25-97.25c-14.29-14.27-14.29-37.43 0-51.71 14.29-14.29 37.43-14.29 51.71 0l123.12 123.11a36.565 36.565 0 0 1 10.71 25.86c0 9.7-3.86 19-10.71 25.86L744.44 831.11c-7.14 7.15-16.5 10.72-25.86 10.72z"
                  p-id="6282"
                ></path>
              </svg>
              导出
            </el-button>
            <!-- <el-radio-group v-model="dataType" size="small">
              <el-radio-button label="报表"></el-radio-button>
              <el-radio-button label="图形"></el-radio-button>
            </el-radio-group> -->
          </div>
        </div>
        <div class="search-result-list">
          <div
            class="table-list"
            v-loading="tableLoading"
            v-if="tableData && tableData.length > 0"
          >
            <div>
              <span v-html="tableTitle"></span>
            </div>

            <el-table
              :data="tableData"
              style="width: 100%"
              v-if="activeTab === '3'"
            >
              <el-table-column
                prop="month"
                label="日期"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                prop="businessPartnerName"
                label="贸易伙伴"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="registrationRegionName"
                label="注册地"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="tradeModeName"
                label="贸易方式"
              ></el-table-column>
              <el-table-column label="第一数量">
                <template #default="scope">
                  {{ scope.row.firstCount }}
                  {{
                    scope.row.firstCountUnit
                      ? "（" + scope.row.firstCountUnit + "）"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column label="第二数量">
                <template #default="scope">
                  {{ scope.row.secondCount }}
                  {{
                    scope.row.secondCountUnit
                      ? "（" + scope.row.secondCountUnit + "）"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column label="金额">
                <template #default="scope">
                  {{
                    scope.row.money && scope.row.money === "rmb"
                      ? "￥"
                      : scope.row.money && scope.row.money === "usd"
                      ? "$"
                      : ""
                  }}
                  {{ scope.row.amount }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            class="no-data"
            v-if="showTable && (!tableData || tableData.length === 0)"
          >
            <div class="tip">
              <svg
                t="1626241932884"
                class="icon"
                viewBox="0 0 1428 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2321"
                width="60"
                height="60"
              >
                <path
                  d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                  p-id="2322"
                ></path>
                <path
                  d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                  p-id="2323"
                ></path>
                <path
                  d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                  p-id="2324"
                ></path>
                <path
                  d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                  p-id="2325"
                ></path>
                <path
                  d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                  p-id="2326"
                ></path>
                <path
                  d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                  p-id="2327"
                ></path>
              </svg>
              <div class="text">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";
import districts from "@/assets/geoMap/geo/districts.js";
import worldCapitalsCoordinates from "@/assets/geoMap/geo/worldCapitalsCoordinates.js";
import AMapLoader from "@amap/amap-jsapi-loader";
import { exportTongjiDownload } from "../../util/utils";

let AMap = null;

export default {
  components: {},
  data() {
    return {
      tableData: [],
      loading: false,
      hideTimer: null,
      provinceShowIng: null,
      activeTab: "3",
      selectRegion: "北京市",
      cnames: [],
      cnameLoading: false,
      regionDataNameOptions: [],
      selectDate: [],
      dataType: 0,
      total: 0,
      pageCount: 0,
      cnameTabs: [],
      activeCName: "",
      oldActiveCName: "",
      pageIndex: 1,
      yearCodeList: [],
      tableTitle: "",
      tableLoading: false,
      selectStartYear: null,
      selectEndYear: null,
      cnameTableHead: [],
      cnameTableHeadUnit: [],
      dyzUnit: "",
      ljzUnit: "",
      tbzzUnit: "",
      ljzzUnit: "",
      showTable: false,
      jckType: "jinkou",
      jckMoney: "rmb",
      jckGoodsName: "",
      jinchukouDataNameOptions: [
        { label: "螺母", value: "螺母" },
        { label: "塑料制餐具及厨房用具", value: "塑料制餐具及厨房用具" },
        { label: "塑料制机器及仪器用零件", value: "塑料制机器及仪器用零件" },
        {
          label: "插头及插座，线路电压≤1000V",
          value: "插头及插座，线路电压≤1000V",
        },
        {
          label: "直流电动机及直流发电机，输出功率≤750W",
          value: "直流电动机及直流发电机，输出功率≤750W",
        },
        { label: "发光二极管(LED)", value: "发光二极管(LED)" },
        { label: "电视显像管零件", value: "电视显像管零件" },
        { label: "雷达显示管零件", value: "雷达显示管零件" },
        { label: "半导体基电动机", value: "半导体基电动机" },
        { label: "机动车辆用卤钨灯", value: "机动车辆用卤钨灯" },
      ],
      showIsHover: false,

      map: null,
      loca: null, //地图动画渲染实例对象
      key: "4b04138c130005c228e166162f08c437", // 开发应用的 ID
      mapStyle: "amap://styles/ef94c91b1fe470206ef0b6c2fa041033",
      mapCenterPoint: [116.2317, 39.5427], //北京坐标
      labelLayer: null, //文字图层
      pulseLink: null, //线条层
      scatterLayer: null, //标记动画层
      scatterLayerCenter: null, //中心点样式层
      markfontColor: "#35a5ff", //区域文字颜色
      lineHeadColor: "red", //脉冲头部颜色
      lineTrailColor: "rgba(255, 255,0,0)", //脉冲尾部颜色

      aereData: [],
      districtNames: [],
      mpaLoading: false,
    };
  },
  created() {
    this.districtNames = districts.map((i) => i.name);
  },
  mounted() {
    this.mapInit();
  },
  methods: {
    handleExport() {
      this.exportJinchukouDataTable();
    },
    exportJinchukouDataTable() {
      let startYearCode = "",
        endYearCode = "";

      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      let url = `${process.env.VUE_APP_BASE_API}/search/export-jinchukou-data-table`;
      let data = `region=${this.selectRegion}&type=${
        this.jckType || "jinkou"
      }&money=${this.jckMoney || "rmb"}&goodsName=${
        this.activeCName
      }&startYearCode=${startYearCode}&endYearCode=${endYearCode}`;

      this.handleExportDownload(url, data);
    },
    handleExportDownload(url, data) {
      exportTongjiDownload(url, this.activeCName, data);
    },
    jinchukouDataNameRemote(query) {
      if (query) {
        this.jinchukouDataNameOptions = [];
        axiosRequest(
          "/search/jinchukou-data-name-match",
          { text: query, region: this.selectRegion || "" },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data.code === 200) {
              if (
                res.data.data.goodsName_count &&
                res.data.data.goodsName_count.length > 0
              ) {
                const list = [];
                res.data.data.goodsName_count.forEach((item) => {
                  list.push({ value: item.key, label: item.key });
                });
                this.jinchukouDataNameOptions = list;
              }
            }
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      if (!this.selectRegion) {
        this.$message({ message: "请选择地区！", type: "warning" });
        return;
      }
      if (!this.cnames || this.cnames.length === 0) {
        this.$message({ message: "请选择商品名称！", type: "warning" });
        return;
      }

      this.cnameTabs = this.cnames;
      this.activeCName = this.cnameTabs[0];
      this.oldActiveCName = this.activeCName;

      this.jinchukouDataTableMatch();
    },
    jinchukouDataTableMatch() {
      this.tableLoading = true;
      this.showTable = true;

      let startYearCode = "",
        endYearCode = "";

      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      const selectDistricts = districts.find(
        (i) => i.name === this.selectRegion
      );
      if (selectDistricts && selectDistricts.center) {
        this.mapCenterPoint = selectDistricts.center;
      }

      axiosRequest(
        "/search/jinchukou-data-table-match",
        {
          region: this.selectRegion,
          type: this.jckType || "jinkou",
          money: this.jckMoney || "rmb",
          goodsName: this.activeCName,
          startYearCode: startYearCode,
          endYearCode: endYearCode,
          pageIndex: this.pageIndex,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data.records;
            let tableAereData = [];
            this.tableData.forEach((item) => {
              let year = item.month.substring(0, 4);
              let month = item.month.substring(4);
              let dateStr = year + "年";
              if (month && month !== "00") {
                dateStr += month + "月";
              }
              item.month = dateStr;

              const coordinates =
                worldCapitalsCoordinates[item.businessPartnerName];
              let aereDataIndex = tableAereData.findIndex(
                (i) => i.areaName === item.businessPartnerName
              );
              if (aereDataIndex < 0 && coordinates && coordinates.length > 0) {
                tableAereData.push({
                  areaName: item.businessPartnerName,
                  coordinates: coordinates,
                });
              }
            });
            this.aereData = tableAereData;
          }
          this.tableLoading = false;
          this.mapInit();
          //   console.log(this.tableData);
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleTabClick(val) {
      if (this.activeTab !== "3") {
        this.$router.push("/tongji/index");
      }
      this.showIsHover = !this.showIsHover;
      //   this.regionDataNameOptions = [];
      //   this.cnames = [];
      //   this.cnameTabs = [];
      //   this.tableData = [];
      //   this.showTable = false;
    },
    handleRegionDataTabClick(val) {
      if (this.oldActiveCName !== val.name) {
        this.pageIndex = 1;
        this.tableData = [];
        this.oldActiveCName = val.name;

        if (this.activeTab === "3") {
          this.jinchukouDataTableMatch();
        } else {
          this.regionDataTableMatch();
        }
      }
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },

    //初始化地图
    mapInit() {
      this.mpaLoading = true;
      AMapLoader.load({
        key: this.key,
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [],
        Loca: {
          version: "2.0.0",
        },
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
      })
        .then((map) => {
          AMap = map;
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            zoom: 2.5,
            pitch: 46,
            center: this.mapCenterPoint,
            mapStyle: this.mapStyle,
            showBuildingBlock: true, // 显示建筑物
            showLabel: false, // 不显示地名什么的
            dragEnable: true, //是否允许拖拽
            zoomEnable: true, //是否允许缩放
          });
          //全局化数据地图渲染实例对象
          this.loca = new Loca.Container({
            map: this.map,
          });
          // 文字图层初始化
          this.labelLayer = new AMap.LabelsLayer({
            rejectMapMask: true,
            collision: true,
            animation: true,
          });
          this.map.add(this.labelLayer);
          //线条层初始化
          this.pulseLink = new Loca.PulseLinkLayer({
            zooms: [2, 20],
            zIndex: 10,
            visible: true,
            opacity: 1,
            depth: true,
          });
          //标记动画层
          this.scatterLayer = new Loca.ScatterLayer({
            zIndex: 10,
            opacity: 0.8,
            visible: true,
            zooms: [2, 22],
          });
          //中心点层
          this.scatterLayerCenter = new Loca.ScatterLayer({
            zIndex: 10,
            opacity: 0.8,
            visible: true,
            zooms: [2, 22],
          });
          this.SetDataToMap();

          setTimeout(() => {
            this.mpaLoading = false;
          }, 500);
        })
        .catch((e) => {
          this.mpaLoading = false;
          //console.log(e);
        });
    },
    //数据转换为图形添加到地图中
    SetDataToMap() {
      let centerCoord = this.mapCenterPoint; //[116.2317, 39.5427]; //北京坐标
      //所有区域标记渲染
      this.SetlabelLayer(this.aereData);
      //标记中心点
      this.markerCenter(centerCoord);
      //脉冲线渲染
      this.SetpulseLink(this.aereData);

      //执行动画
      this.loca.animate.start();
    },
    //标记中心点添加mark(中心点坐标)
    markerCenter(data) {
      let centerPoint = new Loca.GeoJSONSource({
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: data,
              },
            },
          ],
        },
      });
      this.scatterLayerCenter.setSource(centerPoint);
      //标注中心点样式
      this.scatterLayerCenter.setStyle({
        size: [300000, 300000],
        unit: "meter",
        texture: "https://a.amap.com/Loca/static/static/center-point.png",
      });
      //3D渲染出标注点
      this.loca.add(this.scatterLayerCenter);

      var labelsMarker = new AMap.LabelMarker({
        name: this.selectRegion,
        position: data,
        zooms: [2, 22],
        opacity: 1,
        zIndex: 10,
        text: {
          content: this.selectRegion,
          direction: "bottom",
          offset: [0, -5],
          style: {
            fontSize: 13,
            fontWeight: "normal",
            fillColor: this.markfontColor,
          },
        },
      });
      this.labelLayer.add(labelsMarker);
    },
    //渲染文字图形(区域坐标数据)
    SetlabelLayer(data) {
      this.labelLayer.clear();
      data.forEach((item) => {
        var labelsMarker = new AMap.LabelMarker({
          name: item.areaName,
          position: item.coordinates,
          zooms: [2, 22],
          opacity: 1,
          zIndex: 10,
          text: {
            content: item.areaName,
            direction: "bottom",
            offset: [0, -5],
            style: {
              fontSize: 13,
              fontWeight: "normal",
              fillColor: this.markfontColor,
            },
          },
        });
        this.labelLayer.add(labelsMarker);
      });
      //mark图形动画处理
      var source = this.jsonToGeoObj(data);
      this.scatterLayer.setSource(source);
      this.scatterLayer.setStyle({
        size: [500000, 500000],
        unit: "miter",
        animate: true,
        duration: 1000,
        texture: "https://a.amap.com/Loca/static/static/orange.png",
      });
      this.loca.add(this.scatterLayer);
    },
    //脉冲线处理
    SetpulseLink(data) {
      var stype = 1; //控制方向
      var source = this.jsonToGeoLine(data, this.mapCenterPoint, stype);
      // console.log(source)
      this.pulseLink.setSource(source);
      this.pulseLink.setStyle({
        unit: "meter",
        dash: [40000, 0, 40000, 0],
        lineWidth: function () {
          return [20000, 10000];
        },
        height: function (index, feat) {
          return feat.distance / 3 + 10;
        },
        // altitude: 1000,
        //脉冲速度
        smoothSteps: 3000,
        speed: function (index, prop) {
          return 1000 + Math.random() * 200000;
        },
        flowLength: 1000000,
        lineColors: function (index, feat) {
          return ["#42a5f5"];
        },
        // maxHeightScale: 0.3, // 弧顶位置比例
        maxHeightScale: stype == 0 ? 0.3 : 0.7,
        headColor: this.lineHeadColor, //脉冲头部颜色
        trailColor: this.lineTrailColor, //脉冲尾部颜色
      });
      this.loca.add(this.pulseLink);
    },
    //json转换成geoMark对象
    jsonToGeoObj(json) {
      var ArrayList = [];
      json.forEach((item) => {
        let iobj = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: item.coordinates,
          },
        };
        ArrayList.push(iobj);
      });
      var newJSON = {
        type: "FeatureCollection",
        features: ArrayList,
      };
      return new Loca.GeoJSONSource({
        data: newJSON,
      });
    },
    //json转换geoLine对象(type: 0)
    //startPoint:单点区域坐标
    //type:线条方向type=0：1对多  type=1:多对一
    jsonToGeoLine(json, startPoint, stype) {
      var ArrayList = [];
      json.forEach((item) => {
        let iobj = {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates:
              stype === 0
                ? [startPoint, item.coordinates]
                : [item.coordinates, startPoint],
          },
        };
        ArrayList.push(iobj);
      });
      var newJSON = {
        type: "FeatureCollection",
        features: ArrayList,
      };
      return new Loca.GeoJSONSource({
        data: newJSON,
      });
    },
  },
};
</script>

<style>
.amap-logo {
  display: none !important;
  visibility: hidden !important;
}

.amap-copyright {
  display: none !important;
  visibility: hidden !important;
}

.cnames-width {
  width: 90%;
  max-width: 400px;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";

.table-list ::v-deep .el-table {
  td.el-table__cell,
  th.el-table__cell.is-leaf {
    border-left: 1px solid #ebeef5;
    text-align: center;
  }
}
.search-filter .el-date-editor ::v-deep .el-range-input {
  text-align: center;
}
#body {
  padding-top: 25px;

  ::v-deep .el-date-editor {
    .el-range__icon {
      margin-left: 5px;
      margin-top: 1px;
    }
    .el-range-separator {
      width: auto;
      line-height: 30px;
    }
  }
}
.top-show {
  position: relative;
  margin-bottom: 20px;

  .search-filter {
    position: absolute;
    left: 0;
    top: 60px;
    width: 462px;
    padding: 20px;
    background-color: rgba(242, 252, 253, 0.8);

    ::v-deep {
      .el-form-item__content {
        padding-right: 0;
      }
    }
    .el-form {
      max-height: inherit;
    }
    .el-form-item {
      border: 0;
    }
    .el-select {
      width: 100%;
    }
    .submit {
      @media screen and (max-width: 768px) {
        margin-top: 10px;
        .el-button {
          width: 100%;
        }
      }
      ::v-deep .el-form-item__content {
        margin-left: 0 !important;
      }
      text-align: center;
      // .el-button {
      // }
    }
  }
  .map {
    height: 475px;
  }
}

.search-top {
  height: 44px !important;
  ::v-deep {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__nav-wrap:after {
      display: none;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      font-size: 16px;
      line-height: 40px;
    }
  }
  .search-top-time {
    float: left;
  }
  .search-display {
    float: right;
    .el-button {
      padding: 5px 15px;
      background-color: transparent;
    }
    svg {
      width: 20px;
      height: 20px;
      vertical-align: -5px;
    }
  }
}
@media screen and (max-width: 768px) {
  .top-show {
    .map {
      display: none;
    }
    .search-filter {
      position: relative;
      top: 0;
      width: auto;
      height: auto;

      padding: 10px 15px;
      .el-date-editor {
        width: calc(100% / 2 - 20px) !important;
      }
      .el-range-editor {
        width: 100% !important;
      }
      .el-radio-group {
        width: 100%;
      }
    }
  }
  .search-top-time {
    float: none !important;
  }
  .search-display {
    display: none;
  }
}
</style>